import { createFileRoute } from "@tanstack/react-router";
import { Forms1Page } from "@/components/pages/Forms1Page";

export const Route = createFileRoute("/forms1")({
  head: () => ({
    meta: [
      { title: "Fale com a Kentro — Formulário rápido em chat" },
      {
        name: "description",
        content:
          "Responda 5 perguntas rápidas em um chat e nossa equipe entra em contato pelo WhatsApp para mostrar a Kentro na prática.",
      },
      { property: "og:title", content: "Fale com a Kentro — Formulário rápido em chat" },
      {
        property: "og:description",
        content:
          "Formulário conversacional da Kentro: nome, telefone, tamanho da empresa, e-mail e empresa em menos de 1 minuto.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: Forms1Page,
});
